import React from 'react'
import ReactDOM from 'react-dom'
import { VideoProps, VideoState, VideoTrackType } from './types'
import splitVideoTrackName from '@bt-react/libs/splitVideoTrackName'
import classnames from 'classnames'
import get from 'lodash/get'
import styles from './Video.module.scss'

class Video extends React.Component<VideoProps, VideoState> {

  private ref: HTMLVideoElement | null = null

  refCallback = node => {

    if (!node) return

    this.ref = node
    this.setState({ refSet: true })

  }

  constructor (props) {

    super(props)
    /* @ts-ignore */
    this.containerEl = document.createElement("div");
    this.state = {
      isSubscribed: false,
      quality: '',
      playable: false,
      playing: false,
      refSet: false
    }

  }

  componentDidMount () {

    if (get(this.props.publication, 'track') !== null) this.setIsSubscribed()
    else this.addListeners(this.props.publication)

  }

  componentDidUpdate (prevProps, prevState) {

    if (
      (!prevState.isSubscribed && this.state.isSubscribed && this.state.refSet) ||
      (this.state.isSubscribed && prevState.refSet !== this.state.refSet)
    ) this.createTrack()

    if (
      (prevState.playable !== this.state.playable && this.state.refSet) ||
      (this.state.playable && prevState.refSet !== this.state.refSet)
    ) this.playTrack()

  }

  componentWillUnmount () {

    this.removeListeners(this.props.publication)

  }

  playTrack = async () => {

    if (!this.ref) return

    try {

      if (Reflect.has(this.ref, 'play')) await this.ref.play()

      if (this.ref && this.ref.paused) setTimeout(this.playTrack, 100)

    }
    catch (e) {

      console.log(e.message)

    }

  }

  setIsSubscribed = (): void => this.setState({ isSubscribed: true })
  unsetIsSubscribed = (): void => this.setState({ isSubscribed: false })

  addListeners = (publication: VideoProps['publication']) => {

    if (!publication || !publication.on) return
    publication.on('subscribed', this.setIsSubscribed)
    publication.on('unsubscribed', () => this.unsetIsSubscribed)

  }

  removeListeners = (publication: VideoProps['publication']) => {

    if (!publication || !publication.removeListener) return
    publication.removeListener('subscribed', this.setIsSubscribed)
    publication.removeListener('unsubscribed', this.unsetIsSubscribed)

  }

  async createTrack () {

    if (this.props.publication === null || this.props.publication.track === null || !this.ref) return

    const { quality } = splitVideoTrackName(this.props.publication.trackName)
    if (typeof quality !== 'undefined') this.setState({ quality: quality.toString() })

    try {

      await this.props.publication.track.attach(this.ref)

    }
    catch (e) {

      console.log(e)

    }

  }

  handleCanPlay = () => this.setState({ playable: true })
  handlePlay = () => this.setState({ playing: true })

  render () {

    if (!this.props.publication) return null

    const {
      mirrorVideo = false,
      trackType = VideoTrackType.WEBCAM
    } = this.props

    const videoClasses = classnames(styles['video'], {
      [styles[`video--mirrored`]]: mirrorVideo
    })

    return <video
      height={'100%'}
      width={'auto'}
      ref={this.refCallback}
      data-id={this.props.trackSid}
      data-bdd={`talks-track-video`}
      data-visible={!this.props.isHidden}
      data-track-type={trackType}
      autoPlay={true}
      className={videoClasses}
      hidden={this.props.isHidden}
      onPlay={this.handlePlay}
      onCanPlayThrough={this.handleCanPlay}
    />

  }

}

export default Video
